module.exports = __webpack_public_path__ + "media/dogs/barking-labrador-3cde4d93.svg";